/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {MappingRoutePageComponent} from './mapping-route-page.component';


export function mappingStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider.state('app.dat-map.mappings', {
          url: '/mappings',
          views: {
            'content@app': {
              component: MappingRoutePageComponent
            },
            'title@app': stateTitleView()
          },
          data: {
            title: 'Mappings'
          }
        });
  }, adnRouterHelper);
}
